import { lazy } from "react";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import { ADDITIONAL, COVERAGE_EXCLUSIONS_PAGE, COVERAGE_PAGE, COVERAGE_ROOT, INTERESTED_PARTIES_PAGE, RISK_LOCATION_PAGE } from "./Business.constants";


const CoverageRoot = Loadable(
  lazy(() =>
  import("./CoverageRoot").then(
    ({ CoverageRoot }) => ({
    default: CoverageRoot,
    })
  )
  )
);
const CoveragePage = Loadable(
  lazy(() =>
    import(
      "./Coverage/CoveragePage"
    ).then(({ CoveragePage }) => ({
      default: CoveragePage,
    }))
  )
);
const RiskLocationPage = Loadable(
  lazy(() =>
    import(
      "./RiskLocation/RiskLocationPage"
    ).then(({ RiskLocationPage }) => ({
      default: RiskLocationPage,
    }))
  )
);
const InterestedPartiesPage = Loadable(
  lazy(() =>
    import(
      "./InterestedParties/InterestedPartiesPage"
    ).then(({ InterestedPartiesPage }) => ({
      default: InterestedPartiesPage,
    }))
  )
);
const CoverageExclusionsPage = Loadable(
  lazy(() =>
    import(
      "./CoverageExclusions/CoverageExclusionsPage"
    ).then(({ CoverageExclusionsPage }) => ({
      default: CoverageExclusionsPage,
    }))
  )
);
const Additional = Loadable(
  lazy(() =>
    import(
      "./AdditionalInterest/AdditionalInterest"
    ).then(({ Additional }) => ({
      default: Additional,
    }))
  )
);
export const BusinessRiskCoverageRoutes = [
  
  {
              path: `${COVERAGE_ROOT}/:customerPolicyId`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                  <CoverageRoot />
                </AuthorizedRoute>
              ),
            },
            {
              path: `${COVERAGE_PAGE}`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                  <CoveragePage />
                </AuthorizedRoute>
              ),
            },
            {
              path: `${COVERAGE_PAGE}/:coverageId`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                  <CoveragePage />
                </AuthorizedRoute>
              ),
            },
            {
              path: `${RISK_LOCATION_PAGE}`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                  <RiskLocationPage />
                </AuthorizedRoute>
              ),
            },
            {
              path: `${RISK_LOCATION_PAGE}/:riskLocationNumber`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                  <RiskLocationPage />
                </AuthorizedRoute>
              ),
            },
            {
              path: `${INTERESTED_PARTIES_PAGE}`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                  <InterestedPartiesPage />
                </AuthorizedRoute>
              ),
            },
            {
              path: `${INTERESTED_PARTIES_PAGE}/:interestedNumber`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                  <InterestedPartiesPage />
                </AuthorizedRoute>
              ),
            },
            {
              path: `${ADDITIONAL}`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                  <Additional />
                </AuthorizedRoute>
              ),
            },
            {
              path: `${ADDITIONAL}/:additionalIntrestNumber`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                  <Additional />
                </AuthorizedRoute>
              ),
            },
            {
              path: `${COVERAGE_EXCLUSIONS_PAGE}`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                  <CoverageExclusionsPage />
                </AuthorizedRoute>
              ),
            },
            {
              path: `${COVERAGE_EXCLUSIONS_PAGE}/:coverageNumber`,
              exact: true,
              element: (
                <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                  <CoverageExclusionsPage />
                </AuthorizedRoute>
              ),
            },
];
